import React, { useState } from "react";
import { motion } from "framer-motion";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const LinkedInTestimonials = ({ linkedinPosts = [] }) => {
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 3;
  const totalPages = Math.ceil(linkedinPosts.length / itemsPerPage);

  const getCurrentPageItems = () => {
    const start = currentPage * itemsPerPage;
    const end = start + itemsPerPage;
    return linkedinPosts.slice(start, end);
  };

  const nextPage = () => {
    setCurrentPage((prev) => (prev + 1) % totalPages);
  };

  const prevPage = () => {
    setCurrentPage((prev) => (prev - 1 + totalPages) % totalPages);
  };

  // Show message if no posts available
  if (!linkedinPosts || linkedinPosts.length === 0) {
    return (
      <div className="w-full text-center py-12">
        <p className="text-gray-400 text-lg">No LinkedIn testimonials available at the moment.</p>
      </div>
    );
  }

  return (
    <div className="w-full">
      {/* LinkedIn Posts Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
        {getCurrentPageItems().map((post, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-4 hover:bg-white/10 transition-all duration-300"
          >
            <div className="w-full h-[500px] overflow-hidden rounded-lg">
              <iframe
                src={post.url}
                height="500"
                width="100%"
                frameBorder="0"
                allowFullScreen=""
                title={`LinkedIn Post ${currentPage * itemsPerPage + index + 1}`}
                className="w-full h-full"
              />
            </div>
          </motion.div>
        ))}
      </div>

      {/* Pagination Controls */}
      {totalPages > 1 && (
        <div className="flex items-center justify-center gap-4">
          <button
            onClick={prevPage}
            className="p-3 bg-white/10 hover:bg-white/20 rounded-full transition-colors"
            aria-label="Previous page"
          >
            <FaChevronLeft className="text-white" />
          </button>

          <div className="flex gap-2">
            {Array.from({ length: totalPages }, (_, i) => (
              <button
                key={i}
                onClick={() => setCurrentPage(i)}
                className={`w-2 h-2 rounded-full transition-all duration-300 ${
                  i === currentPage
                    ? "w-8 bg-gradient-to-r from-blue-400 to-purple-400"
                    : "bg-gray-600 hover:bg-gray-500"
                }`}
                aria-label={`Go to page ${i + 1}`}
              />
            ))}
          </div>

          <button
            onClick={nextPage}
            className="p-3 bg-white/10 hover:bg-white/20 rounded-full transition-colors"
            aria-label="Next page"
          >
            <FaChevronRight className="text-white" />
          </button>
        </div>
      )}

      {/* View More Link */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.5 }}
        className="text-center mt-8"
      >
        <a
          href="https://www.linkedin.com/in/mihirshah99"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 text-blue-400 hover:text-blue-300 transition-colors"
        >
          View all recommendations on LinkedIn
          <svg
            className="w-4 h-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
            />
          </svg>
        </a>
      </motion.div>
    </div>
  );
};

export default LinkedInTestimonials;
